var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"turnstileContainer",staticClass:"turnstile-container"}),(_vm.status === 'loading')?_c('div',{staticClass:"text-sm text-gray-500"},[_vm._v("Memuat verifikasi keamanan...")]):_vm._e(),(_vm.status === 'error')?_c('div',{staticClass:"text-sm text-red-500"},[_vm._v("Gagal memuat keamanan. Silakan refresh.")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }